import { useQuery, UseQueryResult } from '@tanstack/react-query'
import axiosInstance from './axiosInstance'
import { QueryKeys } from './reactQuery'

//types
import { IGetSubscriptionsResponse } from '../interfaces/subscriptions'

//hooks
export function useSubscriptions(): UseQueryResult<IGetSubscriptionsResponse> {
	return useQuery([QueryKeys.SUBSCRIPTIONS], async () => getSubscriptions())
}

async function getSubscriptions() {
	const response = await axiosInstance.get<IGetSubscriptionsResponse>(
		'/app/user/plans/listActive'
	)

	return response.data
}
